import { EllipsisVertical, HelpCircle } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { useOpenUrl } from "../../../../hooks/useOpenUrl";
import { useCallContext } from "../../CallContext";
import { CallDoneDialog } from "../../CallDoneDialog";
import { CallModeMenu } from "../../CallModeMenu";
import { CallStatus } from "../../CallStatus";
import { ToggleTestingMode } from "./CallFooterMenu/ToggleTestingMode";

export const CallFooter = () => {
  const {
    roomBot,
    partyServerConnectionStatus,
    handleRequestBotInfo,
    // Thrashing detection
    isThrashing,
    shouldSuggestRefresh,
    thrashingMessage,
  } = useCallContext();

  const canTest = useFeatureFlag("testing-mode");

  const openUrl = useOpenUrl();

  const status = roomBot?.status_changes?.[
    roomBot.status_changes.length - 1
  ] ?? { code: "starting_up" };

  // Determine if call has ended based on status changes
  // These are Recall bot statuses that indicate the call experience is complete
  // NOTE: "recording_done" is NOT included - it just means a recording segment
  // finished, but the call may still be ongoing (especially common with Zoom)
  const hasCallEnded =
    roomBot?.status_changes?.some((statusChange: { code: string }) => {
      const endedCallStatuses = [
        "call_ended", // Primary signal - all participants left
        "done", // Bot completed all tasks
        "analysis_done", // Analysis complete (if enabled)
        "fatal", // Call failed
      ];
      return endedCallStatuses.includes(statusChange.code);
    }) ?? false;

  return (
    <div className="flex items-center border-t border-gray-300 p-2">
      {/* Scrollable content area for menu items */}
      <div className="flex min-w-0 flex-1 overflow-x-auto">
        <div className="flex items-center space-x-4 pr-2">
          <CallStatus
            status={status?.code}
            handleRequestBotInfo={handleRequestBotInfo}
            partyServerConnectionStatus={partyServerConnectionStatus}
            isThrashing={isThrashing}
            shouldSuggestRefresh={shouldSuggestRefresh}
            thrashingMessage={thrashingMessage}
            hasCallEnded={hasCallEnded}
          />
          <CallModeMenu />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="sm" variant="ghost">
                <EllipsisVertical size={16} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {/* <DropdownMenuItem>Latency: {messageLatency} ms</DropdownMenuItem> */}
              {canTest && <ToggleTestingMode />}
              <DropdownMenuItem
                onClick={() => openUrl("https://intercom.help/frontier-ai/en")}
              >
                <HelpCircle size={12} className="mr-2" /> Help & support
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>

      {/* Fixed leave call button - always visible */}
      <div className="flex-shrink-0 pl-2">
        <CallDoneDialog />
      </div>
    </div>
  );
};
